/**
 * When the user opts into MFA from profile (Me), we PATCH the API so the next auth session
 * should run the optional MFA wizard. We also defer in-app redirects until the next Clerk
 * session by storing the current session id; after sign-out / sign-in the id changes and
 * MfaEnforcedRoute will send the user to /mfa/setup.
 */
const STORAGE_KEY = "diligent_mfa_setup_deferred_clerk_session_id";

export function setMfaSetupDeferredForCurrentClerkSession(sessionId) {
  if (!sessionId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, sessionId);
  } catch {
    /* ignore (private mode, etc.) */
  }
}

export function clearMfaSetupSessionDeferral() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * True when profile opt-in stored this Clerk session id — skip optional /mfa/setup redirect
 * until the user gets a new session (typically next login).
 */
export function shouldDeferMfaSetupRedirectForSession(sessionId) {
  if (!sessionId) return false;
  try {
    return sessionStorage.getItem(STORAGE_KEY) === sessionId;
  } catch {
    return false;
  }
}
